
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Cheapestcabservicemumbai() {



    const cardData =
    {
        keyword: 'Cheapest cab service in navi mumbai',
        heading: 'Skyline Cabs: Cheapest cab service in navi mumbai',
        headingDescription: 'Looking for the cheapest cab service in Navi Mumbai? Skyline Cabs offers economical, safe, and comfortable travel solutions for all your local and outstation needs. Whether it’s a quick city ride or a long-distance trip, we provide pocket-friendly rates without compromising on quality.​​​',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Cheapest Cab Service in Navi Mumbai",
      "description": "Skyline Cabs offers the most economical cab services in Navi Mumbai. Enjoy safe and comfortable rides at the lowest rates in the city."
    },
    {
      "name": "Affordable Taxi Service Navi Mumbai",
      "description": "Looking for an affordable taxi in Navi Mumbai? Skyline Cabs provides dependable and budget-friendly taxi options for local and outstation travel."
    },
    {
      "name": "Budget Cab Service Navi Mumbai",
      "description": "Skyline Cabs brings you budget cab services across Navi Mumbai. Get reliable transportation without breaking the bank."
    },
    {
      "name": "Low Cost Outstation Taxi Navi Mumbai",
      "description": "Travel outstation from Navi Mumbai affordably with Skyline Cabs. We offer low-cost taxi options ideal for long-distance trips."
    }
  ],
  "tableData": [
    ["Cheapest Cab Service in Navi Mumbai", "Affordable Taxi Service Navi Mumbai"],
    ["Budget Cab Service Navi Mumbai", "Low Cost Outstation Taxi Navi Mumbai"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Cheapest Cab Service in Navi Mumbai",
      "WhyChoosedescription": "For budget-friendly and reliable transportation in Navi Mumbai, our cheapest cab service offers great value with no compromise on comfort or safety. Get affordable rides every time."
    },
    {
      "WhyChooseheading": "Affordable Pricing with Transparent Charges",
      "WhyChoosedescription": "Enjoy the lowest fares in Navi Mumbai with a clear, upfront pricing structure. No hidden fees, just honest rates for your daily commutes or special trips."
    },
    {
      "WhyChooseheading": "Comfortable and Reliable Rides",
      "WhyChoosedescription": "Even at the lowest fares, we maintain high standards of comfort. Our well-maintained cabs are equipped with air conditioning and provide a smooth ride for all types of journeys."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our professional drivers are courteous, well-trained, and ensure a safe and pleasant ride at an affordable price. Enjoy peace of mind during your travels in Navi Mumbai."
    },
    {
      "WhyChooseheading": "Multiple Payment Options for Convenience",
      "WhyChoosedescription": "We offer flexible payment methods, including cash, cards, and digital payments, making it easy and convenient for you to pay for your cab ride."
    },
    {
      "WhyChooseheading": "Perfect for Daily Commutes, Shopping, and More",
      "WhyChoosedescription": "Whether it’s for your daily commute, a shopping trip, or visiting family, our cheap Navi Mumbai cab service is perfect for short or long rides within the city."
    },
    {
      "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
      "WhyChoosedescription": "All our cabs are sanitized regularly and maintained to the highest standards, ensuring hygiene, safety, and reliability during your travel around Navi Mumbai."
    },
    {
      "WhyChooseheading": "24/7 Availability and Easy Booking",
      "WhyChoosedescription": "Our cheapest cab service in Navi Mumbai is available 24/7. You can easily book a ride online or via phone, with our customer support team ready to assist at any time."
    }
  ]
  
  
  
  
  
  








    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book the cheapest cab service in Navi Mumbai?',
            answer:
                'Booking the cheapest cab service in Navi Mumbai is simple. You can use apps like Ola Mini, Uber Go, or local Kaali Peeli taxis. Just enter your pickup location in Navi Mumbai, choose your vehicle, and confirm your booking via the app or customer support.',
        },
        {
            id: 2,
            question: 'What is the starting fare for the cheapest cabs in Navi Mumbai?',
            answer:
                'The starting fare for the cheapest cabs like Ola Mini and Uber Go in Navi Mumbai is generally around ₹25-₹30 for the first 2-3 km. After that, the fares increase based on distance traveled.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the cheapest cab options in Navi Mumbai?',
            answer:
                'For budget-friendly cab options in Navi Mumbai, you can choose from vehicles like Tata Indica, Swift Dzire, or smaller hatchbacks offered by services like Ola Mini and Uber Go.',
        },
        {
            id: 4,
            question: 'Are the fares for cheap cabs in Navi Mumbai fixed or metered?',
            answer:
                'The fares for cheap cabs in Navi Mumbai are typically metered. For services like Ola Mini and Uber Go, fares are calculated using their dynamic pricing model, which may vary based on demand and availability.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab with the cheapest services in Navi Mumbai?',
            answer:
                'Yes, both Ola and Uber offer one-way cab bookings in Navi Mumbai, so you can travel from your pickup location to your destination without having to book a return journey.',
        },
        {
            id: 6,
            question: 'Can I pay in cash for the cheapest cabs in Navi Mumbai?',
            answer:
                'Yes, cash payment is accepted by most cheaper cab services like local Kaali Peeli taxis, as well as Ola and Uber. However, Ola and Uber encourage digital payments via the app for convenience.',
        },
        {
            id: 7,
            question: 'Can I cancel or modify my booking for a cheap cab in Navi Mumbai?',
            answer:
                'Yes, you can cancel or modify your booking for cheap cabs in Navi Mumbai using the Ola or Uber app. Cancellation fees may apply depending on the service.',
        },
        {
            id: 8,
            question: 'Are there any discounts or offers on cheap cabs in Navi Mumbai?',
            answer:
                'Yes, both Ola and Uber often offer discounts or promotional codes for rides in Navi Mumbai. You can check for available offers in the app to get reduced fares.',
        },
        {
            id: 9,
            question: 'Is it safe to use the cheapest cab services in Navi Mumbai?',
            answer:
                'Yes, services like Ola, Uber, and local Kaali Peeli taxis ensure passenger safety. The vehicles are regularly maintained, and drivers undergo background checks. You can track your ride in real-time through the app.',
        },
        {
            id: 10,
            question: 'Why should I choose the cheapest cab services in Navi Mumbai?',
            answer:
                'Choosing the cheapest cab services in Navi Mumbai is ideal for budget-conscious travelers. These services offer affordable pricing, flexible booking options, and reliable safety features, making them an excellent choice for daily commutes or short trips around the city.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sameer Patel",
            rating: 5,
            review: "I booked an Ola Mini for a trip within Navi Mumbai. It was incredibly affordable, and the driver was friendly. I recommend it for anyone looking for a budget-friendly option."
        },
        {
            name: "Miss. Nisha Desai",
            rating: 4,
            review: "Uber Go was a great option for my short trip in Navi Mumbai. The ride was smooth, and the fare was reasonable. It would be perfect if the app offered more discount options."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Mumbai",
  "image": "https://skylinecabs.com/assets/images/cheapest-cab-service-mumbai.jpg",
  "description": "Looking for the most affordable cab service in Mumbai? Skyline Cabs offers budget-friendly rides with AC sedans, hatchbacks, and SUVs across the city—available 24/7 with professional drivers and fixed pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "9154"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "199",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/cheapest-cab-service-in-mumbai"
  }
};




    return (
        <div>

<Helmet>
  <title>Cheapest Cab Service in Mumbai | 24/7 Affordable Rides | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Looking for the most affordable cab service in Mumbai? Skyline Cabs offers budget-friendly rides with AC sedans, hatchbacks, and SUVs across the city—available 24/7 with professional drivers and fixed pricing." 
  />
  <meta 
    name="keywords" 
    content="Cheapest Cab Service in Mumbai, Budget Cab Mumbai, Affordable Taxi Mumbai, Lowest Fare Cab in Mumbai, Skyline Cabs Booking, Online Cab Booking Mumbai, Mumbai Local Cabs, Cheap Sedan Taxi Mumbai, AC Cab at Low Price Mumbai, 24/7 Economy Taxi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/110.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cheapestcabservicemumbai;